import React, { useEffect, useRef, useState } from "react";
import * as R from "ramda";
import { CheckboxCard } from "./checkboxCard";
import { ConnectionTypes, CommonServices, PersonalServices, AuxiliarOptions, OtherService, isSocialNetwork, isInsurance } from "../../../../../../constants/utils/connectionTypes";
import { removeUserConnection } from "../../../../../../actions/facilita-api";
import { useDispatch } from "react-redux";

export const ServiceNavbar = ({ selectedService, setSelectedService, activeUserConnections, serviceDatas, setHideComplete, userId, favoriteServices, setFavoriteServices, setShowCompleteState, generateLetters }) => {
	const dispatch = useDispatch();
	const bottomRef = useRef(null);
	const topRef = useRef(null);
	const selectedServiceRef = useRef(null);
	const [selectedServices, setSelectedServices] = useState([]);
	const isFirefox = typeof InstallTrigger !== "undefined";

	const allServices = { ...CommonServices, ...PersonalServices, ...AuxiliarOptions, ...OtherService };
	useEffect(() => {
		// setTimeout(() => {
		//     if (!R.isNil(selectedServiceRef) && !R.isNil(selectedServiceRef.current)) {
		//         selectedServiceRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
		//     }
		// }, 350);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedService]);

	function removeService(connectionType) {
		dispatch(removeUserConnection(userId, connectionType));
		// if (!R.isNil(topRef) && !R.isNil(topRef.current)) {
		//     topRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
		// }
	}

	function isFavorite(connectionType) {
		return favoriteServices.indexOf(connectionType) > -1;
	}

	function AddOrRemoveFromFavorites(connectionType) {
		const isFavorite = favoriteServices.indexOf(connectionType);
		if (isFavorite < 0) {
			setFavoriteServices([...favoriteServices, connectionType]);
		} else {
			setFavoriteServices(favoriteServices.filter((fs) => fs != connectionType));
		}
	}

	// useEffect(() => {
	//     //dispatch(fetchServiceDataForServiceType(selectedService))
	//     // eslint-disable-next-line react-hooks/exhaustive-deps
	// }, [selectedService]);

	// useEffect(() => {
	//     if (!R.isNil(user) && !R.isNil(user.services) && user.services.length > 0) {
	//         setSelectedServices(user.services);
	//         if (!R.isNil(selectedService) && selectedService !== '' && user.services.findIndex(s => s.connectionType === selectedService) === -1) {
	//             let serviceToBeSet = R.sortWith([R.ascend(R.prop('title'))])(Object.entries([].concat(commonOptions, personnalOptions, otherOption).filter(sr => selectedServices.findIndex(r =>
	//                 isSocialNetwork(r.connectionType) ? ConnectionTypes.socialNetworks === sr.connectionType :
	//                     isInsurance(r.connectionType) ? ConnectionTypes.insurance === sr.connectionType :
	//                         r.connectionType === sr.connectionType) !== -1)).map(entry => entry[1]))[0];
	//             setSelectedService(isSocialNetwork(serviceToBeSet.connectionType) ? ConnectionTypes.socialNetworks : isInsurance(serviceToBeSet.connectionType) ? ConnectionTypes.insurance : serviceToBeSet.connectionType);
	//         }
	//     }
	// }, [user.services]);

	const personalServices = [].concat(Object.values(PersonalServices), Object.values(AuxiliarOptions));

	if (R.isNil(selectedService)) {
		return "";
	}

	return (
		<nav className="block flex-row flex-lg-column align-items-center no-scroll">
			<h2 className="sr-only visually-hidden">Services Navigation</h2>
			<header className="block w-lg-100 sticky-auto t-auto-0 z-2 mr-3 mx-lg-auto text-center bg-light pb-1">
				<button
					type="button"
					className="btn btn-icon mx-auto bnt-auto-block o-60 o-100--hover p-0 no-outline"
					onClick={(e) => {
						e.preventDefault();
						if (!R.isNil(topRef) && !R.isNil(topRef.current)) {
							topRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
						}
					}}>
					<i className=" eva eva-arrow-upward-outline fs-4"></i>
				</button>
			</header>
			<ul className={"list-unstyled sticky-auto z-0 grid grid-auto-column w-100" + (isFirefox ? " pb-5" : "")}>
				{R.sortWith([R.ascend(R.prop("order"))])(Object.values(allServices).filter((sr) => activeUserConnections.findIndex((r) => r.connectionType === sr.connectionType) !== -1)).map((s, index) => {
					let votreBanque = false;
					let compteCourant = false;
					let votrePlacements = false;
					let votreAssurance = false;
					let votreCredit = false;
					if (s.connectionType === ConnectionTypes.bank) {
						const bankData = serviceDatas.filter((s) => s.serviceType === "Banques");
						if (!R.isNil(bankData) && bankData.length > 0) {
							votreBanque = true;
							bankData.forEach((bank) => {
								if (compteCourant === false && bank.payload.accounts.findIndex((b) => b.category === "Courant") !== -1) {
									compteCourant = true;
								}
								if (votrePlacements === false && bank.payload.accounts.findIndex((b) => b.category === "Placement") !== -1) {
									votrePlacements = true;
								}
								if (votreAssurance === false && bank.payload.accounts.findIndex((b) => b.category === "Assurance") !== -1) {
									votreAssurance = true;
								}
								if (votreCredit === false && bank.payload.accounts.findIndex((b) => b.category === "Credit") !== -1) {
									votreCredit = true;
								}
							});
						}
					}

					let labels = {
						[ConnectionTypes.bank]: [
							{ isActive: votreBanque, name: "Votre banque" },
							{ isActive: compteCourant, name: "Votre compte courant" },
							{ isActive: votrePlacements, name: "Vos placements" },
							{ isActive: votreAssurance, name: "Vos assurances" },
							{ isActive: votreCredit, name: "Vos credits" },
						],
					};

					return (
						<li
							key={"CommonServices_" + index}
							ref={index === 0 ? topRef : s.connectionType === selectedService.connectionType ? selectedServiceRef : bottomRef}
							role="button"
							className={"card rounded border border-dim " + (selectedService.connectionType === s.connectionType ? " shadow" : "")}
							onClick={(e) => {
								e.preventDefault();
								setSelectedService(s);
								// setHideComplete(true);
							}}>
							<CheckboxCard
								isSelected={selectedService.connectionType === s.connectionType}
								topRef={topRef}
								selectedServices={selectedServices}
								setSelectedServices={setSelectedServices}
								service={s}
								labels={labels[s.connectionType]}
								serviceDatas={serviceDatas}
								removeService={() => removeService(activeUserConnections.find((c) => c.connectionType === s.connectionType))}
								isFavorite={isFavorite(s.connectionType)}
								AddOrRemoveFromFavorites={AddOrRemoveFromFavorites}
							/>
						</li>
					);
				})}

			
				{/* {R.sortWith([R.ascend(R.prop("title"))])(Object.values(CommonServices).filter((sr) => activeUserConnections.findIndex((r) => r.connectionType === sr.connectionType) !== -1)).map((s, index) => {
						let votreBanque = false;
						let compteCourant = false;
						let votrePlacements = false;
						let votreAssurance = false;
						let votreCredit = false;
						if (s.connectionType === ConnectionTypes.bank) {
							const bankData = serviceDatas.filter((s) => s.serviceType === "Banques");
							if (!R.isNil(bankData) && bankData.length > 0) {
								votreBanque = true;
								bankData.forEach((bank) => {
									if (compteCourant === false && bank.payload.accounts.findIndex((b) => b.category === "Courant") !== -1) {
										compteCourant = true;
									}
									if (votrePlacements === false && bank.payload.accounts.findIndex((b) => b.category === "Placement") !== -1) {
										votrePlacements = true;
									}
									if (votreAssurance === false && bank.payload.accounts.findIndex((b) => b.category === "Assurance") !== -1) {
										votreAssurance = true;
									}
									if (votreCredit === false && bank.payload.accounts.findIndex((b) => b.category === "Credit") !== -1) {
										votreCredit = true;
									}
								});
							}
						}

						let labels = {
							[ConnectionTypes.bank]: [
								{ isActive: votreBanque, name: "Votre banque" },
								{ isActive: compteCourant, name: "Votre compte courant" },
								{ isActive: votrePlacements, name: "Vos placements" },
								{ isActive: votreAssurance, name: "Vos assurances" },
								{ isActive: votreCredit, name: "Vos credits" },
							],
						};

						return (
							<li
								key={"CommonServices_" + index}
								ref={index === 0 ? topRef : s.connectionType === selectedService.connectionType ? selectedServiceRef : bottomRef}
								role="button"
								className={"card rounded border border-dim " + (selectedService.connectionType === s.connectionType ? " shadow" : "")}
								onClick={(e) => {
									e.preventDefault();
									setSelectedService(s);
									// setHideComplete(true);
								}}>
								<CheckboxCard
									isSelected={selectedService.connectionType === s.connectionType}
									topRef={topRef}
									selectedServices={selectedServices}
									setSelectedServices={setSelectedServices}
									service={s}
									labels={labels[s.connectionType]}
									serviceDatas={serviceDatas}
									removeService={() => removeService(activeUserConnections.find((c) => c.connectionType === s.connectionType))}
									isFavorite={isFavorite(s.connectionType)}
									AddOrRemoveFromFavorites={AddOrRemoveFromFavorites}
								/>
							</li>
						);
					})}

					{R.sortWith([R.ascend(R.prop("title"))])(personalServices)
						.filter((personalService) =>
							activeUserConnections.some(
								(a) => a.connectionType === personalService.connectionType || (isSocialNetwork(a.connectionType) && personalService.connectionType === AuxiliarOptions.socialNetworks.connectionType) || (isInsurance(a.connectionType) && personalService.connectionType === AuxiliarOptions.insurance.connectionType)
							)
						)
						.map((s, index) => {
							return (
								<li
									key={"PersonalServices_" + index}
									ref={s.connectionType === selectedService.connectionType ? selectedServiceRef : bottomRef}
									role="button"
									className={"card rounded border border-dim " + (selectedService.connectionType === s.connectionType ? " shadow" : "")}
									onClick={(e) => {
										e.preventDefault();
										setSelectedService(s);
										//setHideComplete(true);
									}}>
									<CheckboxCard
										isSelected={selectedService.connectionType === s.connectionType}
										topRef={topRef}
										isSocialNetwork={isSocialNetwork}
										isInsurance={isInsurance}
										selectedServices={selectedServices}
										setSelectedServices={setSelectedServices}
										service={s}
										serviceDatas={serviceDatas}
										removeService={() => {
											removeService(activeUserConnections.find((c) => c.connectionType === s.connectionType));
										}}
										isFavorite={isFavorite(s.connectionType)}
										AddOrRemoveFromFavorites={AddOrRemoveFromFavorites}
									/>
								</li>
							);
						})}

					{R.sortWith([R.ascend(R.prop("title"))])(Object.values(OtherService).filter((sr) => activeUserConnections.some((r) => r.connectionType === sr.connectionType))).map((s, index) => {
						return (
							<li
								key={"OtherService_" + index}
								ref={s.connectionType === selectedService.connectionType ? selectedServiceRef : bottomRef}
								role="button"
								className={"card rounded border border-dim " + (selectedService.connectionType === s.connectionType ? " shadow" : "")}
								onClick={(e) => {
									e.preventDefault();
									setSelectedService(s);
									//setHideComplete(true);
								}}>
								<CheckboxCard
									isSelected={selectedService.connectionType === s.connectionType}
									topRef={topRef}
									selectedServices={selectedServices}
									setSelectedServices={setSelectedServices}
									service={s}
									serviceDatas={serviceDatas}
									removeService={() => removeService(activeUserConnections.find((c) => c.connectionType === s.connectionType))}
									isFavorite={isFavorite(s.connectionType)}
									AddOrRemoveFromFavorites={AddOrRemoveFromFavorites}
								/>
							</li>
						);
					})} */}
			</ul>
			<footer className="block w-lg-100 sticky-auto b-auto-0 z-2 ml-3 mx-lg-auto text-center bg-light pt-1">
				{/* <button type="button" className="btn btn-if btn-block btn-alert-primary p-2 justify-content-between gap-1">
					<span className="o-70 align-middle px-2">J'ai terminé </span>
					<i className="btn-icon eva eva-done-all-outline p-1 o-80 lh-1 fs-root align-middle"></i>
				</button>
				<hr /> */}
				<button
					type="button"
					className="btn btn-icon mx-auto bnt-auto-block o-60 o-100--hover p-0 no-outline"
					onClick={(e) => {
						e.preventDefault();
						if (!R.isNil(bottomRef) && !R.isNil(bottomRef.current)) {
							bottomRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
						}
					}}>
					<i className="eva eva-arrow-downward-outline fs-4"></i>
				</button>
				{generateLetters ? (
					""
				) : (
					<button
						className="btn btn-block bg-white o-80 o-100--hover py-2 my-1 text-primary"
						onClick={() => {
							setShowCompleteState(true);
						}}>
						<span className="o-90 align-middle">Passer à l'étape suivante</span>
					</button>
				)}
			</footer>
		</nav>
	);
};
